// extracted by mini-css-extract-plugin
module.exports = {"paper":"MapLegendContainer_paper__3K2_9","menuPaper":"MapLegendContainer_menuPaper__3NsTn","narrow-scrollbar":"MapLegendContainer_narrow-scrollbar__2BB4V"};